// @flow
/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { Button, Icon, type IconName } from '@zapier/design-system';

type Props = {
  /**
   * Where the `Button` links to.
   */
  href: string,
  /**
   * Name of the icon to render when `isCollapsed`.
   */
  iconName: IconName,
  /**
   * Indicates whether the button is collapsed.
   */
  isCollapsed: boolean,
  /**
   * The content of the button, which will also be used
   * for the `ariaLabel` when `isCollapsed`.
   */
  text: string,
};

const UniversalSidebarSubheaderButton = (props: Props) => {
  // Use `Button` for both the text and `Icon` states
  // instead of `IconButton` so that the component can visually
  // transition from one state to the other. With `IconButton`,
  // the components would unmount and remount the next one.
  return (
    <Button
      ariaLabel={props.text}
      casing="uppercase"
      color="black"
      hasShadow={true}
      href={props.href}
      isFullWidth={true}
      isPadded={!props.isCollapsed}
    >
      {props.isCollapsed ? (
        <Icon isBlock={true} name={props.iconName} size={30} />
      ) : (
        props.text
      )}
    </Button>
  );
};

export default UniversalSidebarSubheaderButton;
